/* eslint-disable css-modules/no-undef-class */
import { useRef } from 'react';
import { Swiper as SwiperInstance } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Typography from '@/components/atoms/typography/typography';
import CarouselNavigation from '@/components/molecules/carousel-navigation/carousel-navigation';
import QuickLinkCard from '@/components/organisms/quick-link-card/quick-link-card';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import styles from './quick-links.module.scss';

export interface QuickLinksProps extends ModuleWrapperProps {
  /** Headline for quick links */
  headline: Content.Components['QuickLinksModuleDto']['headline'];
  /** The items to show */
  items: Content.Components['QuickLinksModuleDto']['items'];
}

const QuickLinks = ({ headline, items, ...rest }: QuickLinksProps) => {
  const swiperRef = useRef<SwiperInstance>();

  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container>
        <Row className={styles.rowWrapper}>
          <Column>
            <Typography className={styles.headline} tagStyle="headingSmall">
              {headline}
            </Typography>
          </Column>

          <Column className={styles.itemsColumn}>
            <Swiper
              className={styles.swiper}
              onSwiper={swiper => {
                swiperRef.current = swiper;
              }}
              slidesPerView="auto"
              spaceBetween={16}
              speed={500}
              wrapperClass={styles.swiperWrapper}
            >
              {items.map((linkItem, linkItemIndex) => {
                return (
                  <SwiperSlide key={linkItemIndex} className={styles.slide}>
                    <QuickLinkCard
                      key={linkItemIndex}
                      icon={linkItem.icon}
                      link={linkItem.link}
                    />
                  </SwiperSlide>
                );
              })}

              <CarouselNavigation showPageCount swiperRef={swiperRef} />
            </Swiper>
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

QuickLinks.displayName = 'QuickLinks';

export default QuickLinks;
